import {get} from "../request/request";

export function getClanLeaderboard(period, column, asc, page, minPlayers) {
    return get(`${window.CLANLEADERBOARD_ENDPOINT_MAP['clanleaderboard']}&period=${period}&column=${column}&asc=${asc}&page=${page}&min_players=${minPlayers}`)
        .then(result => {
            return result;
        });
}

export function getClanLeaderboardDate() {
    return get(`${window.CLANLEADERBOARD_ENDPOINT_MAP['leaderboard_date']}`)
        .then(result => {
            return result;
        });
}

export function getClanStats(clan_id) {
    return get(`${window.CLANLEADERBOARD_ENDPOINT_MAP['clan_data']}&clan_db_id=${clan_id}`)
        .then(result => {
            return result;
        });
}

export function getClanSearch(query) {
    return get(`${window.CLANLEADERBOARD_ENDPOINT_MAP['clan_search']}&query=${query}`)
        .then(result => {
            return result;
        });
}
